<template>
  <div>

    <div class="scenario_part retire-3 scenario_bgs">
      <div class="container">
        <div class="all_wrapper flex">
          <div class="scenario_dialog" key="2" v-if="optionToggle">
            <h2>吃飽了！午後時光別浪費，想去做什麼呢？<br>（可複選）</h2>
            <div class="scenario_option hobbis">
              <label class="option_box"
                     v-for="(item, i) in interests" :key="i">
                <input type="checkbox" v-model="item.toggle">
                <span>{{ item.name }}</span>
              </label>
            </div>
            <div class="col-xs-6 col-xs-offset-3 col-md-2 col-md-offset-5 form-group">
              <div class="share_btn share_btn_blueDefault"><a href="" @click.prevent="toNext('retire_3', 'retire_4')">下一步</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ProgressBar :page="page"></ProgressBar>
    </div>


  </div>
</template>

<script>

import GA from "@/func/seo";
import ProgressBar from '@/components/common/progress_bar'

export default {
  name: "retire_3",
  components: {ProgressBar},
  data: function () {
    return {
      optionToggle: true,
      interestCost: 0,
      interests: [
        {
          name: '游泳',
          cost: 1000,
          toggle: false
        },
        {
          name: '打羽球',
          cost: 2000,
          toggle: false
        },
        {
          name: '打籃球',
          cost: 1000,
          toggle: false
        },
        {
          name: '爬山',
          cost: 1000,
          toggle: false
        },
        {
          name: '健身',
          cost: 1000,
          toggle: false
        },
        {
          name: '園藝',
          cost: 2500,
          toggle: false
        },
        {
          name: '下棋',
          cost: 300,
          toggle: false
        },
        {
          name: '彈琴',
          cost: 600,
          toggle: false
        },
        {
          name: '散步',
          cost: 200,
          toggle: false
        },
        {
          name: '打太極拳',
          cost: 300,
          toggle: false
        },
        {
          name: '瑜珈',
          cost: 300,
          toggle: false
        },
        {
          name: '逛市場',
          cost: 2000,
          toggle: false
        },
        {
          name: '做志工',
          cost: 0,
          toggle: false
        },
        {
          name: '種田',
          cost: 3000,
          toggle: false
        },
        {
          name: '跳舞',
          cost: 2000,
          toggle: false
        },
        {
          name: '唱卡拉OK',
          cost: 300,
          toggle: false
        }
      ],
      page: {
        page_no: 3,
        total: 6,
        isRetire: true
      }
    }
  },
  methods: {
    toNext(from, to) {
      this.addOption3();
      store.dispatch('retire/setInterestsCost', this.addCostInterests())
      store.set('retire/changeShow!', {from, to})
    },
    addCostInterests() {
      this.interests.forEach((interest) => {
        if (interest.toggle) this.interestCost += interest.cost
      })
      return this.interestCost
    },
    addOption3() {
      let optionNo = 'option3'
      let option3 = []
      this.interests.forEach((interest) => {
        if (interest.toggle) option3.push(interest.name)
      })
      let option = JSON.stringify(option3)
      store.dispatch('retire/addOption', {optionNo, option})
    },
  },
  mounted() {
    GA.pushRetireEvent(3, '午後休閒活動')
  }
}

</script>

<style scoped>


</style>
